/**
 * Saborlista Helpers & Viewport Tools
 * Based on Bones, but cleaned and optimized.
 */

/*
 * Get Viewport Dimensions
 * returns object with viewport dimensions to match css in width and height properties
 */
function updateViewportDimensions() {
    var w = window,
        d = document,
        e = d.documentElement,
        g = d.getElementsByTagName('body')[0],
        x = w.innerWidth || e.clientWidth || g.clientWidth,
        y = w.innerHeight || e.clientHeight || g.clientHeight;
    return { width: x, height: y };
}

// Global viewport variable
var viewport = updateViewportDimensions();

/**
 * Throttle Resize-triggered Events
 */
var waitForFinalEvent = (function () {
    var timers = {};
    return function (callback, ms, uniqueId) {
        if (!uniqueId) { uniqueId = "Don't call this twice without a uniqueId"; }
        if (timers[uniqueId]) { clearTimeout(timers[uniqueId]); }
        timers[uniqueId] = setTimeout(callback, ms);
    };
})();

// Resize throttle time
var timeToWaitForLast = 100;

// Update viewport on resize
window.addEventListener('resize', function() {
    waitForFinalEvent(function() {
        viewport = updateViewportDimensions();
    }, timeToWaitForLast, "viewport-update");
});

/**
 * Standard jQuery Ready (if needed)
 */
if (window.jQuery) {
    jQuery(document).ready(function($) {
        // Shared jQuery logic can go here
    });
}
